import styles from "./LandingPageCard.module.scss";

interface LandingPageCardProps {
  children: React.ReactNode;
}

const LandingPageCard = ({ children }: LandingPageCardProps) => {
  return <div className={styles.card}>{children}</div>;
};

export default LandingPageCard;
